export const BORDER_SIZE = "1px";
export const ROW_HEIGHT = "1.4rem";
export const DELETE_COL_WIDTH = ROW_HEIGHT;
export const TYPE_COL_WIDTH = "4rem";
export const VALUE_COL_WIDTH = "6rem";
